import React, { FC, ReactElement, useCallback, useEffect, useState, ReactNode, useMemo } from 'react';
import { LayoutType } from '@om-fe/widgets/dist/components/nav/nav.constants';
import { Spinner } from '@om-fe/widgets/dist/components/spinner/spinner';
import { SportsNavType } from '@om-fe/widgets/dist/widgets/navs/sports-nav/sports-nav.constants';
import { useSportsNavList, UseSportsNavStore } from '@om-fe/widgets/dist/widgets/navs/sports-nav/sports-nav.hooks';
import { WidgetsRouteChangeDetails, WidgetsRouteName } from '@om-fe/widgets/dist/common/routing/routing.constants';
import { navBem } from '@om-fe/widgets/dist/components/nav/nav.utils';
import { BrowserOnly } from '@om-fe/widgets/dist/components/ssr/browser-only';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import { PlatformTypes, isBrowser, listenToMessageAll, ReceivedMessageType, sessionStorage, replaceTemplateStringPlaceholders } from '@om-fe/utils';
import { SportsNav } from '@om-fe/widgets/dist/widgets/navs/sports-nav/sports-nav';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';
import { I18nContextInterface } from '@om-fe/core/core/i18n/utils';
import { Breakpoints, BreakpointsByWidth } from '@om-fe/core/core/store/breakpoints';
import { useItem, useReady } from '@om-fe/store';
import {
    HistoryLocationState,
    OMFE_LIVE_CALENDAR_RELOAD_SPORT_STORAGE_KEY,
    RouteNames,
} from '@om-fe/core/core/routing/utils';
import SimpleSearchTrigger from '@om-fe/core/components/search/simple-search-trigger';
import { AllSportsNavItem } from '@om-fe/core/components/sports-nav/all-sports-nav-item/all-sports-nav-item';
import { SearchPageComponent } from '@om-fe/core/pages/theme1/search-page';
import UserBehaviorTrackingContext from '@om-fe/core/components/user-behavior-tracking-context/user-behavior-tracking-context';
import { UserBehaviorTrackingLocation } from '@om-fe/core/components/user-behavior-tracking-context/user-behavior-tracking.utils';
import TopBetsSecondaryNav from '../top-bets/containers/secondary-nav/nav';
import TopBetsContent from '../top-bets/components/top-bets-content';
import { TopBetsTab } from '../top-bets/utils/top-bets.constants';
import { useParams, useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import RedirectTo from '@om-fe/core/components/redirect-to/redirect-to';
import {
    TopBetsStorageData,
    TopBetsRouteParams,
} from '../top-bets/utils/top-bets.utils';
import { getVirtualStateExtraParams, setVirtualStateExtraParams, setVirtualStateAction } from '@om-fe/core/core/routing/custom-routes/custom-routes.utils';
import SpecialMatchList from '../match-list/containers/special-match-list/special-match-list';
import { DisciplineLiveStatus, DisciplinesType } from '@om-fe/models';
import { DisciplineId } from './match-content-tabs.constants';
import { MatchListItemLayout, MAIN_MARKET_MAX_LIMIT, DEFAULT_DISPLAYED_NUMBER_OF_MATCHES, MAIN_MARKET_MIN_LIMIT, MAIN_MARKET_MEDIUM_LIMIT } from '../match-list/utils/match-list.constants';
import { BonusType, MatchListSpecialHeader } from '../match-list-group/match-list-special-header';
import getConfig, { OMFE2ConfigModel, BannerMatrixConfig, EnvConfig } from '@om-fe/core/utils/config';
import { NavListItemModel } from '../top-bets/containers/secondary-nav/nav.reducer';
import NextRaceEventListPage from '../../pages/next-race/next-race-event-list-page';
import NextRaceBannerPage from '../../pages/next-race/next-race-banner-page';
import { getMainMarketsLimit } from '../match-list/utils/match-list.utils';
import { StreamingCarouselLazy } from '@om-fe/core/components/streaming-carousel/streaming-carousel-lazy-loaders.constants';
import { FavoriteContentTab } from '../favorites/favorites-content-tab';
import { useComponentLoadTime } from '../../utils/top-bets.performance';
import { scrollToNavbar } from '@om-fe/core/utils/dom';
import { useEMRouting } from '@om-fe/core/core/routing/with-routing';
import { CustomContentLoadLazy } from '@om-fe/core/core/widgets/omfe-widgets';
import { CustomContentType } from '@om-fe/core/core/widgets/omfe-widgets/model/omfe-widgets-model';
import { toURIPart } from '@om-fe/core/core/routing/provider';


interface TopBetsMatchesContentPublicProps {
    readonly handleClickAllSports?: () => void;
    readonly allSportsIsSelected?: boolean;
    readonly useStore: UseSportsNavStore;
    readonly bannerContent?: ReactNode;
    readonly bannerContent2?: ReactNode;
    readonly bannerContent3?: ReactNode;
    readonly bannerContent4?: ReactNode;
    readonly isEsportsPage?: boolean;
    readonly selectedSportId?: string;
}

interface TopBetsMatchesContentStoreProps {
    readonly deviceType?: PlatformTypes;
    readonly breakpoints: Breakpoints;
    readonly isLoggedIn: boolean;
}

type TopBetsMatchesContentProps = TopBetsMatchesContentPublicProps & TopBetsMatchesContentStoreProps;

const specialMatchListInstanceId: string = 'special-bet-match-list';
const disableNavItemById: string[] = [DisciplinesType.Olympics];

const config: OMFE2ConfigModel = getConfig();
const specialBonusSingle: boolean = config?.specialBonus?.single;
const specialBonusMulti: boolean = config?.specialBonus?.multi;
const enableAllSportsNavItem: boolean = config?.enableAllSportsNavItem;
const bannerMatrixConfig: BannerMatrixConfig | undefined = config?.bannerMatrix;
const enabledHorseRacing: boolean = config?.enabledHorseRacing ?? false;
const enabledGreyHound: boolean = config?.enabledGreyHound ?? false;
const nextRaceBanerLimitMobile: number | undefined = config?.racingWidgetLimit?.NextRaceBanner?.mobile?.limit;
const nextRaceBanerLoadMoreMobile: boolean | undefined = config?.racingWidgetLimit?.NextRaceBanner?.mobile?.hasLoadMore;
const nextRaceBanerLimitDesktop: number | undefined = config?.racingWidgetLimit?.NextRaceBanner?.desktop?.limit;
const nextRaceBanerLimitLoadMoreDesktop: boolean | undefined = config?.racingWidgetLimit?.NextRaceBanner?.desktop?.hasLoadMore;
const nextRaceEventListLimitMobile: number | undefined = config?.racingWidgetLimit?.NextRaceEventList?.mobile?.limit;
const nextRaceEventListLoadMoreMobile: boolean | undefined = config?.racingWidgetLimit?.NextRaceEventList?.mobile?.hasLoadMore;
const nextRaceEventListLimitDesktop: number | undefined = config?.racingWidgetLimit?.NextRaceEventList?.desktop?.limit;
const nextRaceEventListLimitLoadMoreDesktop: boolean | undefined = config?.racingWidgetLimit?.NextRaceEventList?.desktop?.hasLoadMore;

export interface SportsNavModel {
    readonly id: string;
    readonly name: string;
    readonly shortName: string;
    readonly displayChildren: boolean;
    readonly showEventCategory: boolean;
    readonly liveCounter?: number;
    readonly upcomingCounter?: number;
    readonly isVirtual?: boolean;
}

function getMainMarketsLimitByWidth(width: number, breakpointsByWidth?: BreakpointsByWidth): number {
    const small: number = breakpointsByWidth?.small || 1354;
    const large: number = breakpointsByWidth?.large || 1595;

    if (width <= small) {
        return MAIN_MARKET_MIN_LIMIT;
    } else if (width >= large) {
        return MAIN_MARKET_MAX_LIMIT;
    } else {
        return MAIN_MARKET_MEDIUM_LIMIT;
    }
}

function TopBetsMatchesContentComponent(
    {
        deviceType,
        breakpoints,
        handleClickAllSports,
        allSportsIsSelected,
        useStore,
        bannerContent,
        bannerContent2,
        bannerContent3,
        bannerContent4,
        isEsportsPage = false,
        selectedSportId,
        isLoggedIn,
    }: TopBetsMatchesContentProps,
): ReactElement {
    const { sportRoute, locationRoute } = useParams<TopBetsRouteParams>();
    const location = useLocation();
    const history = useHistory();

    const { gettext, selectedLanguage }: I18nContextInterface = useI18NContext();
    const { getFullPath } = useEMRouting();
    const ready: boolean = useReady(useStore);
    const list: string[] = useSportsNavList(useStore);
    const [redirect, setRedirect] = useState<boolean>(false);
    const [sportId, setSportId] = useState<undefined | string>(selectedSportId);
    const [locationId, setLocationId] = useState<undefined | string>();
    const [categoryId, setCategoryId] = useState<undefined | string>();
    const [locationNavItems, setLocationNavItems] = useState<Record<string, NavListItemModel> | undefined>();
    const [activeLocationTab, setActiveLocationTab] = useState<string>(TopBetsTab.TopBets);
    const [isTopBets, setIsTopBets] = useState<boolean>(true);
    const [isSportIdChanged, setIsSportIdChanged] = useState<boolean>(false);
    const [isSecondaryNavLoading, setIsSecondaryNavLoading] = useState<boolean>(false);
    const [isSportsNavLoading, setIsSportsNavLoading] = useState<boolean>(false);
    const [isTopBetsContentLoading, setIsTopBetsContentLoading] = useState<boolean>(false);
    const [forceTodayTimeRange, setForceTodayTimeRange] = useState<boolean>(false);

    useComponentLoadTime(isSportsNavLoading, 'SportsNav', { deviceType });
    useComponentLoadTime(isSecondaryNavLoading, 'TopBetsSecondaryNav', { deviceType, sportId });
    useComponentLoadTime(isTopBetsContentLoading, 'TopBetsContent', { deviceType, sportId, locationId, categoryId });

    const item: SportsNavModel = useItem<SportsNavModel>(useStore, sportId!);
    const isCategory: boolean | undefined = item?.showEventCategory ?? false;
    const mainMarketsLimit: number = config.mainMarketsLimit?.responsive
        ? config.mainMarketsLimit?.byWidth && (isBrowser() && window)
            ? getMainMarketsLimitByWidth(window.innerWidth, config.mainMarketsLimit?.breakpointsByWidth)
            : getMainMarketsLimit(breakpoints)
        : MAIN_MARKET_MIN_LIMIT;

    const topBetsContentReady = useCallback(() => {
        setIsTopBetsContentLoading(false);
    }, []);

    useEffect(() => {
        if (sportId) {
            setIsTopBetsContentLoading(false);
        } else {
            setIsTopBetsContentLoading(true);
        }
    }, [sportId]);

    useEffect(() => {
        if (sportId && (locationId !== undefined || categoryId !== undefined)) {
            setIsTopBetsContentLoading(true);
        }
    }, [locationId, categoryId, sportId]);

    useEffect(() => {
        if (ready) {
            setIsSportsNavLoading(false);
        } else {
            setIsSportsNavLoading(true);
        }
    }, [ready]);

    useEffect(() => {
        if (config.virtualState) {
            let virtualStateListenerUnsubscribe:() => void;
            virtualStateListenerUnsubscribe = listenToMessageAll(ReceivedMessageType.VirtualStateTrigger, () => {
                const storage: TopBetsStorageData = getVirtualStateExtraParams<TopBetsStorageData>();
                if (storage?.sportId) {
                    setSportId(storage.sportId);
                }
            });

            return () => {
                if (virtualStateListenerUnsubscribe) {
                    virtualStateListenerUnsubscribe();
                }
            };
        }
    }, []);


    useEffect(() => {
        const state = location.state as HistoryLocationState | undefined;
        const sportFromLink: string | undefined = state?.omfeLiveCalendarSportId;
        if (!sportFromLink || !ready || list.length === 0) return;
        if (!list.includes(sportFromLink)) return;

        setSportId(sportFromLink);
        setVirtualStateExtraParams({
            sportId: sportFromLink,
            locationId: sportFromLink === DisciplinesType.ElectronicSports
                ? TopBetsTab.ElectronicSports
                : TopBetsTab.TopBets,
            timeRangeId: undefined,
            matchLimit: 0,
        });
        setForceTodayTimeRange(true);
        setIsSportIdChanged(true);

        const nextState: HistoryLocationState & Record<string, unknown> = {
            ...(state || {}),
            preventScrollTop: deviceType === "mobile"
        };
        delete nextState.omfeLiveCalendarSportId;
        history.replace(`${location.pathname}${location.search}${location.hash}`, nextState);

        if(deviceType === "mobile") {
            scrollToNavbar();
        }

    }, [location.state, location.pathname, location.search, location.hash, list, ready, history]);

    useEffect(() => {
        const storage: TopBetsStorageData = getVirtualStateExtraParams<TopBetsStorageData>();
        const sportStorage: boolean = list.includes(storage?.sportId!);
        const state = location.state as HistoryLocationState | undefined;
        const sportFromLink: string | undefined = state?.omfeLiveCalendarSportId;

        if (sportFromLink) return

        if (
            list.length > 0
            && ((!sportId) || (sportId && !list.includes(sportId)))
        ) {
            if (sportRoute && list.includes(sportRoute)) {
                setSportId(sportRoute);
                return;
            }
            let pendingLiveCalendarSport: boolean = false;
            const fromCalendar: string | null = sessionStorage.getItem(OMFE_LIVE_CALENDAR_RELOAD_SPORT_STORAGE_KEY);
            pendingLiveCalendarSport = !!(fromCalendar && list.includes(fromCalendar));
            if (pendingLiveCalendarSport) {
                if (sportId && !list.includes(sportId)) {
                    return;
                }
            } else {
                if (storage?.sportId) {
                    setSportId(storage.sportId);
                    return;
                }
                const firstIndex: string | undefined = list.find((item) => item !== '' && !isNaN(Number(item)));
                if (firstIndex) {
                    setSportId(firstIndex);
                    return;
                }
            }
        }

        if (!sportId && list.length > 0) {
            const liveCalendarSportId: string | undefined = sessionStorage.getItem(OMFE_LIVE_CALENDAR_RELOAD_SPORT_STORAGE_KEY) || undefined;
            if (liveCalendarSportId && list.includes(liveCalendarSportId)) {
                sessionStorage.removeItem(OMFE_LIVE_CALENDAR_RELOAD_SPORT_STORAGE_KEY);
                setSportId(liveCalendarSportId);
                setVirtualStateExtraParams({
                    sportId: liveCalendarSportId,
                    locationId: liveCalendarSportId === DisciplinesType.ElectronicSports
                        ? TopBetsTab.ElectronicSports
                        : TopBetsTab.TopBets,
                    timeRangeId: undefined,
                    matchLimit: 0,
                });
                setIsSportIdChanged(true);
            } else if (sportRoute) {
                const sportRouteId: boolean = list.includes(sportRoute);
                if (!sportRouteId) {
                    setRedirect(true);
                    setSportId(undefined);
                    setVirtualStateExtraParams({ sportId: undefined, matchLimit: 0 });
                } else {
                    setSportId(sportRoute);
                    setVirtualStateExtraParams({ sportId: sportRoute, matchLimit: 0 });
                }
            } else {
                const newSportId = list.filter((item) => item.indexOf('bannermatrix') < 0);
                if (isEsportsPage) {
                    setSportId(DisciplinesType.ElectronicSports);
                } else {
                    setSportId(sportStorage ? storage?.sportId : newSportId[0]);
                }
                setVirtualStateExtraParams({ sportId: sportStorage ? storage?.sportId : newSportId[0] });
            }
        }

        if (sportRoute && sportId) {
            if (list.length) {
                setVirtualStateExtraParams({ sportId: sportRoute, matchLimit: 0 });
                setIsTopBets(sportId === DisciplinesType.ElectronicSports ? false : sportRoute === TopBetsTab.TopBets);
                const secondaryNavId: string = locationRoute ? locationRoute : activeLocationTab === TopBetsTab.All ? TopBetsTab.All : TopBetsTab.TopBets;
                setActiveLocationTab(secondaryNavId);
            }
        } else if (!sportRoute && sportId) {
            if (list.length) {
                if (sportStorage && storage?.locationId) {
                    setIsTopBets(sportId === DisciplinesType.ElectronicSports ? false : storage.locationId === TopBetsTab.TopBets);
                }
                const secondaryNavId: string = sportStorage && storage?.locationId
                    ? storage.locationId
                    : locationId || categoryId || (sportId === DisciplinesType.ElectronicSports ? TopBetsTab.ElectronicSports : activeLocationTab === TopBetsTab.All ? TopBetsTab.All : TopBetsTab.TopBets);
                setActiveLocationTab(secondaryNavId);
            }
        }

        }, [list, sportId, sportRoute, isEsportsPage, locationRoute, activeLocationTab, locationId, categoryId, location.state]);

    const topBetsNavReady = useCallback((topBetsNavId: string) => {
        setIsSecondaryNavLoading(false);

        if (topBetsNavId === TopBetsTab.TopBets || topBetsNavId === TopBetsTab.All) {
            setLocationId(undefined);
            setCategoryId(undefined);
        } else if (isCategory) {
            setLocationId(undefined);
            setCategoryId(topBetsNavId);
        } else if (!isCategory) {
            setLocationId(topBetsNavId);
            setCategoryId(undefined);
            if (sportId === DisciplinesType.ElectronicSports) {
                setActiveLocationTab(topBetsNavId);
            }
        }
    }, [isCategory, sportId]);

    const onItemClick = useCallback((itemData: WidgetsRouteChangeDetails<WidgetsRouteName.Sport>): void => {
        const { params: { sportId: newSportId } } = itemData;
        setSportId(newSportId);
        setVirtualStateExtraParams({
            sportId: newSportId,
            locationId: newSportId === DisciplinesType.ElectronicSports
                ? TopBetsTab.ElectronicSports
                : TopBetsTab.TopBets,
            timeRangeId: undefined,
            matchLimit: 0,
        });
        setIsSportIdChanged(true);
        setIsSecondaryNavLoading(true);
    }, []);

    useEffect(() => {
        if (isSportIdChanged) {
            setIsSportIdChanged(false);
            setLocationId(undefined);
            setCategoryId(undefined);
            setActiveLocationTab(sportId === DisciplinesType.ElectronicSports ? TopBetsTab.ElectronicSports : TopBetsTab.TopBets);
            setIsTopBets(sportId === DisciplinesType.ElectronicSports ? false : true);
            setVirtualStateExtraParams({
                locationId: sportId === DisciplinesType.ElectronicSports
                    ? TopBetsTab.ElectronicSports
                    : TopBetsTab.TopBets,
                timeRangeId: undefined,
                matchLimit: 0,
            });
            if (bannerMatrixConfig?.showOnFooter) {
                document.querySelector(`#BannerFooter`)?.classList.add('BannerWidgetBannerHidden');
            }
        }
    }, [isSportIdChanged, sportId]);

    const noRedirectFilter = useCallback((id?: string) => {
        if (bannerMatrixConfig?.showOnFooter && isBrowser()) {
            document.querySelector(`#BannerFooter`)?.classList.add('BannerWidgetBannerHidden');
        }
        if (id) {
            setActiveLocationTab(id);
            setVirtualStateAction();
            setVirtualStateExtraParams({ locationId: id, timeRangeId: undefined, matchLimit: 0 });
            setIsTopBets(sportId === DisciplinesType.ElectronicSports ? false : id === TopBetsTab.TopBets);
            if (isCategory) {
                setLocationId(undefined);
                setCategoryId(id);
            } else {
                setCategoryId(undefined);
                setLocationId(id);
            }
        }
    }, [isCategory, sportId]);

    const showSeoContent = config?.customContent?.seoContent?.showOnHomepage || false;

    let content: ReactNode;
    let contentLocationNav: ReactNode;

    const enabledNextRace: boolean = !!((sportId === DisciplinesType.HorseRacing && enabledHorseRacing) || (sportId === DisciplinesType.GreyHounds && enabledGreyHound))
    if (enabledNextRace) {
        content = (
            <NextRaceEventListPage
                sportId={sportId}
                numberOfRaces={deviceType === 'mobile' ? nextRaceEventListLimitMobile : nextRaceEventListLimitDesktop}
                enabledLoadMore={deviceType === 'mobile' ? nextRaceEventListLoadMoreMobile : nextRaceEventListLimitLoadMoreDesktop}
            />
        );
    } else if (sportId === DisciplineId.Bonus) {
        content = (
            <>
                {specialBonusSingle && (
                    <>
                        <MatchListSpecialHeader bonusType={BonusType.Single} />
                        <SpecialMatchList
                            showMatchListHeader={false}
                            showMarketInMatchListGroupHeader={true}
                            mainMarketsLimit={MAIN_MARKET_MAX_LIMIT}
                            instanceId={`${specialMatchListInstanceId}-single`}
                            limitNumberOfEvents={DEFAULT_DISPLAYED_NUMBER_OF_MATCHES}
                            liveStatus={DisciplineLiveStatus.BOTH}
                            itemLayout={MatchListItemLayout.Special}
                            bonusType={BonusType.Single}
                        />
                    </>
                )}
                {specialBonusMulti && (
                    <>
                        <MatchListSpecialHeader bonusType={BonusType.Multi} />
                        <SpecialMatchList
                            showMatchListHeader={false}
                            showMarketInMatchListGroupHeader={true}
                            mainMarketsLimit={MAIN_MARKET_MAX_LIMIT}
                            instanceId={`${specialMatchListInstanceId}-multi`}
                            limitNumberOfEvents={DEFAULT_DISPLAYED_NUMBER_OF_MATCHES}
                            liveStatus={DisciplineLiveStatus.BOTH}
                            itemLayout={MatchListItemLayout.Special}
                            bonusType={BonusType.Multi}
                        />
                    </>
                )}
            </>
        );
    } else if (sportId === DisciplineId.Favorites) {
        content = (
            <FavoriteContentTab
                lang= {selectedLanguage ?? 'en'}
                mainMarketsLimit={mainMarketsLimit}
            />
        );
    } else {
        content = sportId && (
            <TopBetsContent
                instanceId={`TopBets-${isCategory ? 'category-'+activeLocationTab: 'location-'+activeLocationTab}`}
                disciplineId={sportId}
                locationId={
                    sportId === DisciplinesType.ElectronicSports
                        ? locationId
                        : locationId === TopBetsTab.TopBets || locationId === TopBetsTab.All
                            ? undefined
                            : locationId
                    }
                categoryId={categoryId === TopBetsTab.TopBets || categoryId === TopBetsTab.All ? undefined: categoryId}
                breakpoints={breakpoints}
                isTopBets={isTopBets}
                isCategory={isCategory}
                mainMarketsLimit={mainMarketsLimit}
                onContentReady={topBetsContentReady}
                forceTodayTimeRange={forceTodayTimeRange}
                onForceTodayTimeRangeHandled={() => setForceTodayTimeRange(false)}
            />
        );
        contentLocationNav = (
            isSportIdChanged
                ? <Spinner />
                : sportId &&
                <div className={navBem()}>
                    <TopBetsSecondaryNav
                        disciplineId={sportId}
                        instanceId={`Top-Bet-Locations-${sportId}`}
                        activeTab={activeLocationTab}
                        preventRedirect={true}
                        noRedirectFilter={noRedirectFilter}
                        isCategory={isCategory}
                        hasAllButton={true}
                        hasTopBetsButton={true}
                        topBetsNavReady={topBetsNavReady}
                        onNavItemsReady={showSeoContent ? setLocationNavItems : undefined}
                        isEsportsPage={isEsportsPage}
                    />
                </div>
        );
    }

    const activeLocationId = locationId || categoryId || '0';
    const activeLocationName: string = (locationNavItems?.[activeLocationId]?.name ?? 'all').toLowerCase();
    const disciplineName = item?.name;

    const seoUrl = useMemo((): string | undefined => {
        const url: string | undefined = config.customContent?.seoContent?.url;
        if (!url || !showSeoContent) return undefined;
        const env: EnvConfig = config.customConfig?.env ?? EnvConfig.Stage;
        const userRoles: string = isLoggedIn ? 'loggedIn' : 'everyone';
        return replaceTemplateStringPlaceholders(url, { selectedLanguage, env, userRoles, disciplineName: disciplineName });
    }, [showSeoContent, config.customConfig?.env, config.customContent?.seoContent?.url, disciplineName, isLoggedIn, selectedLanguage]);

    const payloads: string | undefined = config.customContent?.seoContent?.payloads;

    const routingUrl = useMemo(
        () => {
            if (!disciplineName || !showSeoContent) return null;

            return `${config.customContent?.seoContent?.basePath ?? `/${selectedLanguage}/sport`}/${toURIPart(disciplineName)}-${sportId}/${activeLocationName}-${activeLocationId}/location`},
        [showSeoContent, selectedLanguage, disciplineName, sportId, activeLocationName, activeLocationId]
    );

    const [stableRoutingUrl, setStableRoutingUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!showSeoContent) return;

        setStableRoutingUrl(null);
        const raf = requestAnimationFrame(() => setStableRoutingUrl(routingUrl));
        return () => cancelAnimationFrame(raf);
    }, [showSeoContent, routingUrl]);

    if (redirect) {
        return <RedirectTo routeName={RouteNames.home} />
    }

    const state = location.state as HistoryLocationState | undefined;
    const sportFromLink: string | undefined = state?.omfeLiveCalendarSportId;

    return (
        <UserBehaviorTrackingContext.Provider value={{ userBehaviorTrackingPage: RouteNames.popularEvents, userBehaviorTrackingLocation: UserBehaviorTrackingLocation.PopularMatchList }}>
            <div className={'NavWrapper'}>
                {ready && !isEsportsPage &&
                    <SportsNav
                        key={sportFromLink ? (sportId || 'default') : undefined}
                        activeItemId={sportId}
                        sportRoute={false}
                        virtualSportRoute={getFullPath(RouteNames.newVirtualSports)}
                        onRouteChange={onItemClick}
                        useStore={useStore}
                        className={`${SportsNavType.Popular}SportsNav`}
                        showIcon
                        hasArrows={deviceType === 'desktop'}
                        layoutType={LayoutType.Main}
                        searchComponent={(
                            !enableAllSportsNavItem && (breakpoints.small || breakpoints.medium)
                                ? <SimpleSearchTrigger
                                    defaultSearchMap={SearchPageComponent.defaultSearchMap}
                                    searchRouteName={RouteNames.search}
                                    searchPlaceholder={gettext('Search')}
                                  />
                                : undefined
                        )}
                        allSportsNavItemComponent={(
                            enableAllSportsNavItem && !config.enabledTopMenu &&
                                <AllSportsNavItem
                                    handleClick={handleClickAllSports}
                                    isSelected={allSportsIsSelected}
                                />
                        )}
                        disableEsportNavItem={config.layout?.disableEsportNavItem}
                        disableNavItemById={disableNavItemById}
                        bannerContent={bannerContent}
                        bannerContent2={bannerContent2}
                        bannerContent3={bannerContent3}
                        bannerContent4={bannerContent4}
                    />
                }
            </div>
            {enabledNextRace && <NextRaceBannerPage sportId={sportId}
                numberOfRaces={deviceType === 'mobile' ? nextRaceBanerLimitMobile : nextRaceBanerLimitDesktop}
                enabledLoadMore={deviceType === 'mobile' ? nextRaceBanerLoadMoreMobile : nextRaceBanerLimitLoadMoreDesktop}
            />}
            {contentLocationNav}
            {!!(isEsportsPage && activeLocationTab) && (
                <BrowserOnly>
                    <StreamingCarouselLazy
                        disciplineId={activeLocationTab}
                        instanceId={`streaming-carousel-${activeLocationTab}`}
                    />
                </BrowserOnly>
            )}
            {isSportIdChanged && <Spinner /> }
            {content}
            {(showSeoContent && stableRoutingUrl && seoUrl) &&
                <CustomContentLoadLazy
                    url={seoUrl}
                    contentType={CustomContentType.NORMAL}
                    payloads={payloads}
                    filterBy={[['route', stableRoutingUrl]]}
                />
            }
        </UserBehaviorTrackingContext.Provider>
    );
}

export const TopBetsMatchesContent: FC<TopBetsMatchesContentPublicProps> = connect(
    (state: AppState): TopBetsMatchesContentStoreProps => {
        return {
            deviceType: state.deviceInfo?.platform.type,
            breakpoints: state.breakpoints,
            isLoggedIn: !!state.session.info,
        };
    },
)(TopBetsMatchesContentComponent);
